import React, { Component } from 'react';
import { Tabs, Footer } from '../universalComponents';
import { Search, FilterList as FilterIcon } from '@mui/icons-material';
import { 
  Button, 
  TextField, 
  Dialog, 
  InputAdornment, 
  Typography, 
  Box, 
  Divider,
  Drawer, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  ImageList, 
  ImageListItem, 
  CircularProgress 
} from '@mui/material';
import hpProducts from '../../utils/hpProductList.json';
import FilterList from './components/filterList';

export default class HP extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    
    const products = Array.isArray(hpProducts) ? hpProducts : [];

    this.state = {
      search: '',
      products,
      filteredProducts: products,
      selectedProduct: null,
      viewDialogOpen: false,
      filtersOpen: false,
      filters: [],
      sortVal: '',
      contentLoading: false,
      cartItems: [],
      cartDeals: [],
      dealIDs: [],
    };
  }

  handleSearch = (searchTerm) => {
    const filteredProducts = this.state.products.filter(product => 
      product.productDesc.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.productNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.productType.toLowerCase().includes(searchTerm.toLowerCase())
    );
    this.setState({ filteredProducts, search: searchTerm });
  }

  componentDidMount() {
    const { updateCurrentTab, mobile } = this.props;
    if (!mobile) updateCurrentTab(1);
    

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search) {
      this.handleSearch(params.search);
    }
  }

  formatPrice = (price) => {
    if (!price) return '--';
    const [dollars, cents] = price.toFixed(2).split('.');
    return (
      <span>
        $ {dollars}
        <span style={{ fontSize: '0.7em', verticalAlign: 'super' }}>.{cents}</span>
      </span>
    );
  }

  handleView = (product) => {
    this.setState({ selectedProduct: product, viewDialogOpen: true }, () => {
      this.loadHPContent(product);
    });
  }

  loadHPContent = (product) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `
      var ccs_cc_args = ccs_cc_args || [];
      ccs_cc_args.push(['mf', 'HP']);
      ccs_cc_args.push(['pn', '${product.productNumber}']);
      ccs_cc_args.push(['lang', 'en']);
      ccs_cc_args.push(['market', 'us']);
      (function () {
        var o = ccs_cc_args; o.push(['_SKey', '0019e814']); o.push(['_ZoneId', 'hp-auto-pp']);
        var sc = document.createElement('script'); sc.type = 'text/javascript'; sc.async = true;
        sc.src = 'https://cdn.cs.1worldsync.com/jsc/h1ws.js';
        var n = document.getElementsByTagName('script')[0]; n.parentNode.insertBefore(sc, n);
      })();
    `;
    document.body.appendChild(script);
  }

  updateFilters = (filters) => {
    const { products, sortVal } = this.state;
    const selectedTypes = filters.map(f => f.val);
    const selectedKeys = filters.map(f => f.key);
    
    let filteredProducts = products;

    if (selectedKeys.includes('productType')) {
      filteredProducts = selectedTypes.length > 0
        ? products.filter(product => selectedTypes.includes(product.productType))
        : products;
    }

    if (sortVal) {
      const [field, direction] = sortVal.split(' ');
      filteredProducts = [...filteredProducts].sort((a, b) => {
        const priceA = a.newMap || a.map || 0;
        const priceB = b.newMap || b.map || 0;
        return direction === 'ascending' ? priceA - priceB : priceB - priceA;
      });
    }

    this.setState({ filters, filteredProducts });
  }

  handleSort = (event) => {
    const { products, filters } = this.state;
    const sortVal = event.target.value;
    
    if (!sortVal) {
      const selectedTypes = filters.map(f => f.val);
      const filteredProducts = selectedTypes.length > 0
        ? products.filter(product => selectedTypes.includes(product.productType))
        : products;

      this.setState({ sortVal: '', filteredProducts });
      return;
    }

    const [field, direction] = sortVal.split(' ');
    const selectedTypes = filters.map(f => f.val);
    let filteredProducts = selectedTypes.length > 0
      ? products.filter(product => selectedTypes.includes(product.productType))
      : products;

    filteredProducts = [...filteredProducts].sort((a, b) => {
      const priceA = a.newMap || a.map || 0;
      const priceB = b.newMap || b.map || 0;
      return direction === 'ascending' ? priceA - priceB : priceB - priceA;
    });

    this.setState({ sortVal, filteredProducts });
  }

  handleCloseDialog = () => {
    this.setState({ viewDialogOpen: false });
  }

  render() {
    const { currentTab, mobile } = this.props;
    const { 
      search, 
      filteredProducts, 
      selectedProduct, 
      viewDialogOpen, 
      filtersOpen,
      filters,
      sortVal,
      contentLoading
    } = this.state;
  
    const addToCart = (product, qty) => {
      product.productName = product.productDesc;
      product.stripeProductID = product.productNumber;
      const newProductArray = qty ? [...Array(qty).keys()].map(val => product) : [product];
      const productDeals = this.state.dealIDs.filter(deal => deal.productID === product.sku);
      const stateObj = { cartItems: [...this.state.cartItems, ...newProductArray] };
      if (productDeals.length > 0) {
        stateObj['cartDeals'] = [...this.state.cartDeals, productDeals[0]]
        const encodedDeal = encodeURI(JSON.stringify([...this.state.cartDeals, productDeals[0]]));
        document.cookie = `cartDeals=${encodedDeal}`;
      }
  
      const encodedItems = encodeURI(JSON.stringify([...this.state.cartItems, ...newProductArray]));
      document.cookie = `cartItems=${encodedItems}`;
      this.setState(stateObj);
    }
    const updateCartItemsAndDeals = ({ cartItems, cartDeals }) => {
      this.setState({ cartItems, cartDeals: cartDeals || [] });
    }

    return (
      <div style={{ flexDirection: 'column', display: 'flex', height: '100%' }}>
        {/* Navigation */}
        <div style={{ flex: '0 1 auto' }}>
            <Tabs
              updateCartItemsAndDeals={updateCartItemsAndDeals}
              cartItems={this.state.cartItems}
              cartDeals={this.state.cartDeals}
              currentTab={currentTab}
              mobile={mobile}
            />
        </div>

        {/* Main Content */}
        <div style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', padding: '20px' }}>
          {/* Search and Filter Section */}
          <div style={{ flex: '0 1 auto', display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: mobile ? 'column' : 'row', gap: '10px', alignItems: 'center' }}>
              <TextField
                sx={{
                  fontStyle: 'italic',
                  marginTop: '2vh',
                  height: '55px',
                  width: mobile ? '90%' : '45vw',
                  marginLeft: mobile ? 'auto' : '3vw',
                  marginRight: mobile ? 'auto' : null,
                  '& label.Mui-focused': { color: 'black' },
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': { borderColor: 'black' },
                    '& fieldset': { borderColor: 'black' },
                    borderRadius: '5px'
                  }
                }}
                label='Search Hardware and Supplies'
                variant='outlined'
                value={search}
                onChange={(e) => this.handleSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
              />
              <div style={{ 
                display: 'flex', 
                gap: '10px', 
                width: mobile ? '90%' : null,
                marginLeft: mobile ? 'auto' : null,
                marginRight: mobile ? 'auto' : null
              }}>
                {mobile && (
                  <Button
                    sx={{
                      color: 'black',
                      '&.MuiButton-root': { border: '1px black solid' }
                    }}
                    startIcon={<FilterIcon />}
                    style={{ width: '42vw', marginRight: '6vw', marginTop: '2vh', height: '55px' }}
                    variant='outlined'
                    onClick={() => this.setState({ filtersOpen: true })}
                  >
                    Filters
                  </Button>
                )}
                <FormControl
                  variant='outlined'
                  style={{
                    marginRight: mobile ? null : 'auto',
                    marginLeft: mobile ? null : '15vw',
                    marginTop: '2vh',
                    width: mobile ? '42vw' : '15vw',
                    backgroundColor: 'white',
                    borderRadius: '5px',
                    height: '55px'
                  }}
                >
                  <InputLabel sx={{ color: 'black' }}>Sort</InputLabel>
                  <Select
                    sx={{
                      '.MuiOutlinedInput-notchedOutline': {
                        borderColor: 'black',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'black',
                      }
                    }}
                    value={sortVal}
                    label='Sort'
                    onChange={this.handleSort}
                  >
                    <MenuItem value=''>None</MenuItem>
                    <MenuItem value='map ascending'>Price: Low to High</MenuItem>
                    <MenuItem value='map decending'>Price: High to Low</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'row', marginTop: '4vh' }}>
            {/* Filters Section - Desktop Only */}
            {!mobile && (
              <div style={{ width: '18vw' }}>
                <FilterList filters={filters} mobile={mobile} updateFilters={this.updateFilters} products={this.state.products} />
              </div>
            )}

            {/* Products List */}
            <div style={{ 
              flex: 1,
              marginLeft: '2vw',
              marginRight: mobile ? '2vw' : 'auto',
              backgroundColor: '#fff',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <ImageList id='imageList' cols={1} gap={10}
                sx={{
                  marginTop: 0,
                  '::-webkit-scrollbar': { display: 'none' },
                  width: '95%',
                  height: '95%',
                  alignContent: 'flex-start'
                }}
              >
                {filteredProducts && filteredProducts.length > 0 ? (
                  filteredProducts.map((product, index) => (
                    <div key={`${product.productNumber}-${index}`}>
                      <ImageListItem style={{ border: '1px solid rgba(0,0,0,0.1)', padding: '10px', borderRadius: '10px' }}>
                        <div style={{ display: 'flex', width: '100%' }}>
                          <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            flexGrow: 1, 
                            padding: '10px',
                            flexDirection: mobile ? 'column' : 'row'
                          }}>
                            <div style={{ 
                              display: 'flex', 
                              flexDirection: 'column', 
                              width: mobile ? '100%' : '60%',
                              marginBottom: mobile ? '10px' : 0
                            }}>
                              <span style={{ fontSize: mobile ? '12pt' : '14pt', marginBottom: '4px' }}>{product.productDesc}</span>
                              <span style={{ fontSize: mobile ? '10pt' : '11pt', color: '#8F0000' }}>{product.productType}</span>
                              <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
                                <span style={{ fontSize: mobile ? '11pt' : '12pt', color: 'rgba(0,0,0,0.5)' }}>Starting at:</span>
                                <span style={{ fontSize: mobile ? '15pt' : '17pt' }}>
                                  {product.newMap ? this.formatPrice(product.newMap) : product.map ? this.formatPrice(product.map) : '--'}
                                </span>
                              </div>
                            </div>
                            <div style={{ 
                              display: 'flex', 
                              flexDirection: 'column', 
                              justifyContent: 'space-between', 
                              alignItems: mobile ? 'flex-start' : 'flex-end', 
                              width: mobile ? '100%' : '40%'
                            }}>
                              <span style={{ fontSize: mobile ? '10pt' : '11pt', color: 'rgba(0,0,0,0.5)' }}>Part Number: {product.productNumber}</span>
                              <div>
                                <Button
                                  variant='contained'
                                  sx={{
                                    bgcolor: '#0D95F2',
                                    '&:hover': { 'bgcolor': '#2273F2' },
                                    color: 'white',
                                    width: mobile ? '100%' : '150px',
                                    marginTop: 'auto',
                                    fontSize: mobile ? '9pt' : '10pt',
                                    padding: mobile ? '8px' : '6px'
                                  }}
                                  onClick={() => this.handleView(product)}
                                >
                                  View Details
                                </Button>
                                <Button
                                  variant='contained'
                                  sx={{
                                    bgcolor: '#0D95F2',
                                    '&:hover': { 'bgcolor': '#2273F2' },
                                    color: 'white',
                                    width: mobile ? '100%' : '150px',
                                    marginTop: 'auto',
                                    fontSize: mobile ? '9pt' : '10pt',
                                    padding: mobile ? '8px' : '6px',
                                    marginLeft: mobile ? '0' : '10px',
                                  }}
                                  onClick={() => {addToCart(product)}}
                                >Add to Cart</Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ImageListItem>
                    </div>
                  ))
                ) : (
                  <div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                    <span style={{ fontSize: '14pt' }}>
                      No Products to Display
                    </span>
                  </div>
                )}
              </ImageList>
            </div>
          </div>
        </div>

        {/* HP Content Dialog */}
        <Dialog
          open={viewDialogOpen}
          onClose={this.handleCloseDialog}
          maxWidth="lg"
          fullWidth
        >
          {selectedProduct && (
            <>
              {/* Fixed Header */}
              <Box sx={{ 
                position: 'sticky', 
                top: 0, 
                backgroundColor: 'white', 
                zIndex: 1,
                borderBottom: '1px solid #e0e0e0',
                p: 2
              }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="h5" component="h2">
                      {selectedProduct.productDesc}
                    </Typography>
                    <Typography variant="h6" sx={{ color: '#0D95F2', mt: 1 }}>
                      {selectedProduct.newMap ? this.formatPrice(selectedProduct.newMap) : selectedProduct.map ? this.formatPrice(selectedProduct.map) : '--'}
                    </Typography>
                  </Box>
                  <Button 
                    variant="contained"
                    onClick={this.handleCloseDialog}
                    sx={{ 
                      backgroundColor: '#0D95F2',
                      '&:hover': { backgroundColor: '#0B7AC7' },
                      color: 'white'
                    }}
                  >
                    Close
                  </Button>
                </Box>
                <Box sx={{ mt: 1 }}>
                  <Typography variant="subtitle1" color="text.secondary">
                    Part Number: {selectedProduct.productNumber}
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    Category: {selectedProduct.productType}
                  </Typography>
                </Box>
              </Box>

              {/* Scrollable Content */}
              <Box sx={{ 
                p: 2,
                maxHeight: 'calc(100vh - 200px)',
                overflowY: 'auto'
              }}>
                <div id="ccs-explore-product" style={{ minHeight: '50px', marginBottom: '20px' }}></div>
                <Divider sx={{ mb: 3 }} />
                <div id="ccs-inline-content" style={{ minHeight: '200px' }}>
                  {contentLoading && (
                    <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'center', 
                      alignItems: 'center',
                      minHeight: '200px'
                    }}>
                      <CircularProgress sx={{ color: '#0D95F2' }} />
                    </Box>
                  )}
                </div>
              </Box>
            </>
          )}
        </Dialog>

        {/* Filters Drawer - Mobile Only */}
        {mobile && (
          <Drawer
            anchor="right"
            open={filtersOpen}
            onClose={() => this.setState({ filtersOpen: false })}
          >
            <Box sx={{ width: 250, p: 3 }}>
              <FilterList filters={filters} mobile={mobile} updateFilters={this.updateFilters} products={this.state.products} />
            </Box>
          </Drawer>
        )}

        {/* Footer */}
        <div style={{ flex: '0 1 auto' }}><Footer /></div>
      </div>
    );
  }
} 